module.exports = __webpack_public_path__ + "static/portfolio-2-63add25a8fa563c9b293a0f601c26cea.jpg";